// Silence is Golden

// ─── Safe-triangle fix for "Shop by Vehicle" nested dropdown ──────────────────
//
// Problem: When moving diagonally from a make item (e.g. "Acura") toward the
// model list, the cursor briefly passes through a sibling make item below it.
// That triggers mouseleave on the Acura <li>, which instantly closes the model
// list via DesktopNavigation.closeDropdown — before the cursor can reach it.
//
// Fix: Patch closeDropdown so nested nav-dropdowns (not mega-menus) get a
// 150 ms grace period. If the cursor enters the model list during that window
// the close is cancelled and instead fires when the cursor leaves the model list.
// If the cursor re-enters the make item the close is also cancelled and a fresh
// leave-listener is re-attached for next time.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  function patchDesktopNav() {
    var DesktopNav = customElements.get('desktop-navigation');
    if (!DesktopNav) return;

    var _origClose = DesktopNav.prototype.closeDropdown;

    DesktopNav.prototype.closeDropdown = function (parentEl) {
      var self = this;
      var menuItem = parentEl.querySelector('[aria-controls]');
      if (!menuItem) { _origClose.call(self, parentEl); return; }

      var dropdown = document.getElementById(menuItem.getAttribute('aria-controls'));

      // Only apply the delay to nested nav-dropdowns — mega-menus close normally
      if (!dropdown || dropdown.classList.contains('mega-menu')) {
        _origClose.call(self, parentEl);
        return;
      }

      var closeTimer;

      function doClose() {
        dropdown.removeEventListener('mouseenter', onDropdownEnter);
        parentEl.removeEventListener('mouseenter', onParentReenter);
        _origClose.call(self, parentEl);
      }

      // Cursor reached the model list during the grace period — cancel the
      // timer and instead close when the cursor eventually leaves the model list.
      function onDropdownEnter() {
        clearTimeout(closeTimer);
        parentEl.removeEventListener('mouseenter', onParentReenter);
        dropdown.addEventListener('mouseleave', doClose, { once: true });
      }

      // Cursor moved back into the make item — cancel the timer and re-attach
      // a leave-listener so the next departure is handled correctly.
      function onParentReenter() {
        clearTimeout(closeTimer);
        dropdown.removeEventListener('mouseenter', onDropdownEnter);
        parentEl.addEventListener('mouseleave', function (e) {
          if (e.relatedTarget !== null) {
            self.closeDropdown(parentEl);
          }
        }, { once: true });
      }

      closeTimer = setTimeout(doClose, 150);
      dropdown.addEventListener('mouseenter', onDropdownEnter, { once: true });
      parentEl.addEventListener('mouseenter', onParentReenter, { once: true });
    };
  }

  // Patch as soon as the element is defined (handles both load orders)
  customElements.whenDefined('desktop-navigation').then(patchDesktopNav);
  if (customElements.get('desktop-navigation')) patchDesktopNav();
})();

// Product and contact-page help use Alhena's installed SDK; never loads a second widget or sends a message.
(function () {
  var pendingButton = null;
  var subscribedWidget = null;
  var retryTimer;
  var timeoutTimer;

  function openProductChat() {
    var widget = window.gleenWidget;
    if (!pendingButton || !widget || typeof widget.open !== 'function') return;
    if (subscribedWidget !== widget) {
      subscribedWidget = widget;
      widget.on('widget:loaded', openProductChat);
      widget.on('widget:opened', function () {
        if (!pendingButton) return;
        pendingButton.removeAttribute('aria-busy');
        pendingButton = null;
        clearInterval(retryTimer);
        clearTimeout(timeoutTimer);
      });
    }
    clearInterval(retryTimer);
    if (typeof widget.setUserMetadata === 'function') {
      if (pendingButton.dataset.productTitle) {
        widget.setUserMetadata('product_name', pendingButton.dataset.productTitle);
        widget.setUserMetadata('product_url', pendingButton.dataset.productUrl);
      } else {
        widget.setUserMetadata('page_name', pendingButton.dataset.pageTitle);
        widget.setUserMetadata('page_url', pendingButton.dataset.pageUrl);
      }
    }
    widget.open();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jci-product-chat]');
    if (!button) return;
    if (pendingButton) pendingButton.removeAttribute('aria-busy');
    clearInterval(retryTimer);
    clearTimeout(timeoutTimer);
    pendingButton = button;
    button.setAttribute('aria-busy', 'true');
    var status = button.parentElement.querySelector('.jci-product-chat__status');
    status.hidden = true;
    retryTimer = setInterval(openProductChat, 250);
    timeoutTimer = setTimeout(function () {
      if (!pendingButton) return;
      pendingButton.removeAttribute('aria-busy');
      pendingButton = null;
      clearInterval(retryTimer);
      status.textContent = 'Chat is still loading. Please try again in a moment.';
      status.hidden = false;
    }, 10000);
    openProductChat();
  });
})();
